import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZArray, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { HStack, Spacer, VStack, XButton, XIconButton, XScroll, XText } from "IZOX/_X";
import Options from "shared/Options";
import _ from "lodash";
import Styles from "__SYSDefault/Styles";
import { QForm } from "IZOX/BLOCKS/Libs";
import { MdClose } from "react-icons/md";
import QUICKUI from "shared/QUICKUI";

/**
 * @augments {Component<Props, State>}
 */
class ViewClientW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(props){
    super();
    this.state = {
      mode: "view",
      formValue: props?.doc ?? {}
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(ViewClientW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _validateCI = () => {
    let {formValue} = this.state;
    let valid = ZValidate.CheckAllFields(formValue, 
      ["meta.fullName.EN", "meta.gender",
        "telNo", "email", 
        "meta.primaryAddress.EN"], "required");
    if(!valid) return false;
    let additionalAddresses = Accessor.Get(formValue, "meta.additionalAddress");
    if(additionalAddresses){
      for(let i = 0; i < additionalAddresses?.length; i++){
        let o = additionalAddresses[i];
        valid = ZValidate.CheckAllFields(o, ["EN"], "required");
        if(!valid) return false;
      }
    }
    return true;
  }

  _close = () => {
    let {Refresh} = this.props;
    Refresh?.();
    GFunc.CloseBackdrop();
  }

  _addRow = (name) => {
    let {formValue} = this.state;
    let target = Accessor.Get(formValue, name) ?? [];
    target = [...target, ""];
    Accessor.Set(formValue, name, target);
    this._onFormChange(formValue);
  }

  _removeRow = (name, idx) => {
    let {formValue} = this.state;
    let target = Accessor.Get(formValue, name) ?? [];
    target = ZArray.DeleteIdx(target, idx);
    Accessor.Set(formValue, name, target);
    this._onFormChange(formValue);
  }

  _onFormChange = (formValue) => {
    this.setState({
      formValue: formValue
    });
  }

  _toView = () => {
    this.setState({
      mode: "view"
    });
  }

  _toEdit = () => {
    this.setState({
      mode: "edit"
    });
  }

  _toSuccess = () => {
    this.setState({
      mode: "success"
    });
  }

  _onSubmit = async () => {
    let {formValue} = this.state;
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/Agent/EditClient", {
        docID: formValue._id,
        formValue
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth fitHeightToContent spacing={30}>
          <HStack pH={16}>
            <XText fontSize={28} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Client Updated Successfully",
                TC: "已成功更新客戶"
              })}
            </XText>
          </HStack>
          <HStack pH={16}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} bold>
              {LocaleX.Parse({
                EN: "It will be shown on the Client Management page",
                TC: "將會顯示在客戶管理頁面"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtn} width={200} onPress={this._close}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to dashboard",
                    TC: "返回"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Close",
                  TC: "關閉"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderTextPreview(label, value, width = 320){
    return (
      <VStack width={width} spacing={5}>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={14} color={ColorX.CSS("Gray4")}>
            {LocaleX.Parse(label)}
          </XText>
        </HStack>
        <HStack HAlign="[" spacing={4}>
          <XText fontSize={14} color={ColorX.CSS("Stone")}>
            {LocaleX.Parse(value)}
          </XText>
        </HStack>
      </VStack>
    );
  }

  renderTitleBar(){
    return (
      <HStack pH={16} shadow>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Client Details",
            TC: "客戶詳細資料"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  renderView(){
    let {doc} = this.props;
    let {telNo, email, meta} = doc ?? {};
    let {fullName, disHKID, gender, 
      primaryAddress, additionalAddress} = meta ?? {};
    return (
      <VStack fullWidth spacing={20} pH={16} pT={24}>
        <HStack HAlign="[">
          {QUICKUI.TextPreview({
            EN: "Full name (english)",
            TC: "姓名 (英文)"
          }, fullName?.EN)}
          {QUICKUI.TextPreview({
            EN: "Full name (Chinese)",
            TC: "姓名 (中文)"
          }, fullName?.TC)}
        </HStack>
        <HStack HAlign="[">
          {QUICKUI.TextPreview(
            {EN: "Email", TC: "電郵"},
            email ?? "NULL"
          )}
          {QUICKUI.TextPreview(
            {EN: "Gender", TC: "性別"},
            Options.GetOption("Gender", gender)?.cap ?? "NULL"
          )}
        </HStack>
        <HStack HAlign="[">
          {QUICKUI.TextPreview({
            EN: "HKID",
            TC: "香港身份證"
          }, disHKID)}
          {QUICKUI.TextPreview({
            EN: "Phone number",
            TC: "電話號碼"
          }, `+852 ${telNo}`)}
        </HStack>
        <HStack HAlign="[">
          {QUICKUI.TextPreview(
            {EN: "Address (English)", TC: "地址 (英文)"},
            primaryAddress?.EN ?? "NULL",
            "100%"
          )}
          {QUICKUI.TextPreview(
            {EN: "Address (Chinese)", TC: "地址 (中文)"},
            primaryAddress?.TC ?? "NULL",
            "100%"
          )}
        </HStack>
        {_.map(additionalAddress, (o, i) => {
            return (
              <HStack key={i}>
                {QUICKUI.TextPreview(
                  {
                    EN: `Additional Address #${i+1}`,
                    TC: `附加地址 #${i+1}`
                  },
                  `${additionalAddress?.[i]?.EN}` ?? "NULL",
                  "100%"
                )}
                {QUICKUI.TextPreview(
                  {
                    EN: "(Chinese)",
                    TC: "(中文)"
                  },
                  `${additionalAddress?.[i]?.TC}` ?? "NULL",
                  "100%"
                )}
              </HStack>
            );
          })}
        {QUICKUI.PopupFooterButton(this._close, this._toEdit, 
          {
            nextCap: {
              EN: "Update",
              TC: "更新"
            }
          })}
      </VStack>
    );
  }

  renderEdit(){
    let {formValue, loading} = this.state;
    let {meta} = formValue ?? {};
    let {additionalAddress} = meta ?? {};
    return (
      <VStack fullWidth>
        <XScroll height={400} fullWidth pH={16}>
          <QForm onChange={this._onFormChange} p={8} spacing={16}
            fullWidth value={formValue}>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("meta.fullName.EN",
                {EN: "Full name", TC: "姓名"}, {
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "meta.fullName.EN"),
                  ["required"])
                })}
              {QUICKUI.WebTextField("meta.fullName.TC",
                {EN: "Full name (Chinese name)", TC: "姓名(中文)"},
                {starred: false})}
            </HStack>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("email",
                {EN: "Email", TC: "電郵"},
                {width: "50%", 
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "email"),
                  ["required", "email"])
                }
              )}
              {QUICKUI.WebDropdown("meta.gender", {
                EN: "Gender",
                TC: "性別"
              }, Options.GetOptionList("Gender"), {
                placeholder: {
                  EN: "Gender",
                  TC: "性別"
                },
                width: 329,
                errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "meta.gender"),
                ["required"])
              })}
            </HStack>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("meta.HKID",
                {EN: "HKID number", TC: "香港身份證號碼"}, {
                  placeholder: {
                    EN: "Please leave blank if no changes are required.",
                    TC: "不需改變請留空"
                  },
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "meta.HKID"),
                  ["isHKID"])
                })}
              {QUICKUI.WithZipCode("telNo", 
                { EN: "Mobile phone", TC: "手機號碼" },
                { 
                  placeholder: {
                    EN: "Enter your mobile phone no.",
                    TC: "輸入你的電話號碼"
                  },
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "telNo"),
                  ["required"])
                })}
            </HStack>
            <HStack HAlign="[" spacing={16}>
              {QUICKUI.WebTextField("meta.primaryAddress.EN",
                {EN: "Primary address (English)", TC: "主要地址 (英文)"},
                {width: "50%",
                  errorMessage: ZValidate.GetErrorMsg(Accessor.Get(formValue, "meta.primaryAddress.EN"),
                  ["required"])
                },
              )}
              {QUICKUI.WebTextField("meta.primaryAddress.TC",
                {EN: "(Chinese)", TC: "(中文)"},
                {width: "50%", starred: false},
              )}
            </HStack>
            <VStack HAlign="[" spacing={24} fullWidth>
              {_.map(additionalAddress, (o, i) => {
                return (
                  <HStack VAlign="_" key={i} HAlign="[" spacing={16}>
                    {QUICKUI.WebTextField(`meta.additionalAddress.${i}.EN`, 
                      {
                        EN: `Additional Address #${i+1} (English)`,
                        TC: `附加地址 #${i+1} (英文)`
                      }, {width: "50%", starred: false})}
                    {QUICKUI.WebTextField(`meta.additionalAddress.${i}.TC`, 
                      {
                        EN: "(Chinese)",
                        TC: "(中文)"
                      }, {width: "44%", starred: false})}
                    <XButton color={ColorX.CSS("Blood")} padding={5} height={40}
                      onPress={() => this._removeRow("meta.additionalAddress", i)}>
                      <MdClose/>
                    </XButton>
                  </HStack>
                );
              })}
              <XButton color={ColorX.CSS("Axit")} 
                onPress={() => this._addRow("meta.additionalAddress")}>
                <HStack>
                  <XText bold>
                    {LocaleX.Parse({
                      EN: "+ Add more address",
                      TC: "+ 增加更多地址"
                    })}
                  </XText>
                </HStack>
              </XButton>
            </VStack>
          </QForm>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._close, this._onSubmit, 
          {
            nextCap: {
              EN: "Submit",
              TC: "提交"
            },
            validateNext: this._validateCI
          }, loading)}
      </VStack>
    );
  }

  renderMain(){
    let {mode} = this.state;
    switch(mode){
      default: case "view": return this.renderView();
      case "edit": return this.renderEdit();
      case "success": return this.renderSuccess();
    }
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        width={705} maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        {this.renderMain()}
      </VStack>
    );
  }

}

export default observer(ViewClientW);
